{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".test_sliders");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".testSlidePrev");
        const nextArrow = slider.parentElement.querySelector(".testSlideNext");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          speed: 1000,
          navigation: {
            nextEl: ".testSlideNext",
            prevEl: ".testSlidePrev",
          },
          breakpoints: {
            150: {
              slidesPerView: 1.2,
              spaceBetween: 12,
            },
            576: {
              slidesPerView: 2.4,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.8,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}